import React from 'react';
import FormSectionHeader from '../../common/FormSectionHeader';
import { checkIfDefaultExceptionFlow, checkIfBothExceptionFlow } from './utils';
import DefaultExceptionFlow from './DefaultExceptionFlow';
import ADEExceptionFlow from './ADEExceptionFlow';
import BothExceptionFlow from './BothExceptionFlow';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withExceptionDetailsHOC } from './withExceptionDetailsHOC';

const styles = (theme) => ({
  fullWidth: { width: '100%' },
  flexRow: {
    display: 'flex',
    gap: '10px'
  },
  flexRowItem: {
    flex: 1
  },
  warningText: {
    color: theme.warningTextColorDispatch,
    fontSize: theme.textFontSize
  },
  exceptionHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    marginTop: 10,
    textTransform: 'uppercase',
    letterSpacing: 1.5
  },
  deleteExceptionButton: {
    color: theme.violationColor,
    padding: 8
  }
});

const ExceptionDetails = ({
  classes,
  DispatchStore,
  configJSON,
  isDeliveryException,
  editInfo,
  onChange,
  shipmentPieces,
  deliveryException,
  exceptionFlow,
  maxExceptionNumberLength,
  exceptionNumberLabel
}) => {
  const isDefaultExceptionFlow = checkIfDefaultExceptionFlow(exceptionFlow);
  const isBothExceptionFlow = checkIfBothExceptionFlow(exceptionFlow);
  const { getExceptionDetailsObject } = deliveryException;

  const handleChange = (index) => (name) => (value) => {
    const exceptionsArray = editInfo.exception || [];
    const updatedExceptionsArray = exceptionsArray.map((exception, idx) => {
      if (idx === index) {
        return {
          ...exception,
          [name]: value,
          errorInfo: {
            ...exception.errorInfo,
            [name]: deliveryException.validateExceptionField(name, value)
          }
        };
      }
      return exception;
    });
    onChange && onChange('exception')(updatedExceptionsArray);
  };

  const handleAddException = () => {
    const exceptionsArray = editInfo.exception || [];
    const updatedExceptionsArray = [...exceptionsArray, getExceptionDetailsObject()];
    onChange && onChange('exception')(updatedExceptionsArray);
  };

  const handleRemoveException = (index) => {
    const exceptionsArray = editInfo.exception || [];
    const updatedExceptionsArray = exceptionsArray.filter((_, i) => i !== index);
    onChange && onChange('exception')(updatedExceptionsArray);
  };

  const isMultipleExceptionsEnabled =
    isDeliveryException && configJSON?.enableMultipleExceptionDetails;

  // Common props shared by BothExceptionFlow and DefaultExceptionFlow
  const commonProps = {
    classes,
    DispatchStore,
    editInfo,
    onChange: handleChange,
    isDeliveryException,
    shipmentPieces,
    handleAddException,
    handleRemoveException,
    isMultipleExceptionsEnabled
  };

  const renderExceptionFlow = () => {
    if (isBothExceptionFlow) {
      return (
        <BothExceptionFlow
          {...commonProps}
          onChangeException={onChange}
          configJSON={configJSON}
        />
      );
    }
    
    if (isDefaultExceptionFlow) {
      return (
        <DefaultExceptionFlow
          {...commonProps}
        />
      );
    }
    
    return (
      <ADEExceptionFlow
        classes={classes}
        DispatchStore={DispatchStore}
        editInfo={editInfo}
        onChange={handleChange}
        isDeliveryException={isDeliveryException}
        maxExceptionNumberLength={maxExceptionNumberLength}
        exceptionNumberLabel={exceptionNumberLabel}
      />
    );
  };

  return (
    <div>
      {isDeliveryException && <FormSectionHeader label={'OS & D Details'} uppercase />}
      {renderExceptionFlow()}
    </div>
  );
};

export default compose(
  withStyles(styles),
  withExceptionDetailsHOC
)(ExceptionDetails);
